import React, {useState} from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {InvoiceOrdersFilter} from '../components/InvoiceOrdersFilter/InvoiceOrdersFilter';
import {InvoiceOrdersTableEditAndSend} from '../components/InvoiceOrdersTable/InvoiceOrdersTableEditAndSend';
import {InvoiceOrdersTableConfirmCustomers} from '../components/InvoiceOrdersTable/InvoiceOrdersTableConfirmCustomers';
import {InvoiceOrdersFooter} from '../components/InvoiceOrdersFooter/InvoiceOrdersFooter';
import Tabs from '../../_common/components/Tabs';
import {shallowEqual, useSelector} from 'react-redux';
import FooterBar from '../../_common/components/FooterBar';

export function InvoiceOrdersCard() {
  const [activeTab, setActiveTab] = useState('common');
  const {count: confirmCustomersCount} = useSelector(
    (state) => ({count: state.invoiceOrdersConfirmCustomers.totalCount}),
    shallowEqual
  );
  const {count: editAndSendCount} = useSelector(
    (state) => ({count: state.invoiceOrdersEditAndSend.totalCount}),
    shallowEqual
  );

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'invoice-orders-list-card'}>
      <InvoiceOrdersFilter/>
      <Tabs
        setActiveTab={setActiveTab}
        items={[
          {
            key: 'common',
            title: 'הזמנות',
            icon: <i className="flaticon2-list"/>,
            content: <InvoiceOrdersTableEditAndSend/>,
          },
          {
            key: 'admin',
            title: `חשבוניות בבירור - ${confirmCustomersCount}`,
            icon: <i className="flaticon2-user"/>,
            content: <InvoiceOrdersTableConfirmCustomers/>,
          },
        ]}
      />
      <FooterBar>
        <InvoiceOrdersFooter
          activeTab={activeTab}
          confirmCustomersCount={confirmCustomersCount}
          editAndSendCount={editAndSendCount}
        />
      </FooterBar>
    </Card>
  );
}
